import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';

export function useMoveConversationToFamily() {
  const queryClient = useQueryClient();

  const {
    mutate,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<{ data: unknown }, Error, { id: string; familyId: string }>({
    mutationFn: ({ id, familyId }) => api.patch(`conversations/${id}`, { familyId }),
    onError: moveError =>
      notifyAndLogError(
        'Could not move chat',
        'The chat could not be moved into the family. Please try again.',
        moveError,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['conversations'] });
    },
  });

  const moveConversationToFamily = (id: string, familyId: string) => mutate({ id, familyId });

  return { moveConversationToFamily, error, isLoading, reset };
}
